import { Cliente } from '../../pessoa/cliente/cliente';
import { Representante } from '../../pessoa/representante/representante';

/** Utilizada para pré-baixar um cliente */
export class ClienteCarteiraPreBaixar {
    idCliente: number;
    cliente: Cliente;
    representante: Representante;
    dataPreBaixa: Date;
    preBaixaManual: boolean;
    nomeUsuarioPreBaixa: string;
    motivoPreBaixa: string;
}
